import Swiper from "swiper/bundle";
import "./_testimonials.scss";

document.addEventListener("DOMContentLoaded", () => {
  const sliderTestimonials = document.querySelectorAll(".slider-testimonials");

  sliderTestimonials.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      spaceBetween: 16,
      slidesPerView: 1,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  });
});
